module.exports = __webpack_public_path__ + "static/media/android-chrome-512x512.c97c31d4.png";